export default __webpack_public_path__ + "static/media/marking--discrete--give-way-row.d469bc27.png";